import {checkServerAvailability, FQDN_HOSTS, RETRY_TIMEOUT} from './connection';


const createInternetAvailabilityChecker = (
    onChange: (isPublicInternetAvailability: boolean) => void
) => {
    let retryTimeoutId:number = null;

    const stop = () => {
        if (retryTimeoutId !== null) {
            clearTimeout(retryTimeoutId);
            retryTimeoutId = null;
        }
    };

    const check = (checkPublicInternet = true) => {
        if (checkPublicInternet) {
            checkServerAvailability(FQDN_HOSTS)
                .then(onChange)
            ;
        }
    };

    const scheduleRetry = () => {
        stop();
        retryTimeoutId = window.setTimeout(check, RETRY_TIMEOUT);
    };

    return {check, scheduleRetry, stop};
};

export {createInternetAvailabilityChecker};
